import { render } from "./SellersList.vue?vue&type=template&id=c30fa3b0&ts=true"
import script from "./SellersList.vue?vue&type=script&lang=ts"
export * from "./SellersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__